import { calendarRef } from './consts';

export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${calendarRef} {
    min-height: 50px;
    padding: 10px;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
  }
  .${calendarRef} h2 {
    font-weight: revert;
  }
  .${calendarRef} .fc .fc-toolbar-title {
    font-size: 1.45em;
  }
  .${calendarRef} a:not(.timeslot-link),a:hover:not(.timeslot-link) {
    color: revert;
  }
  </style>
`;
  bm.add(calendarRef, {
    label: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-calendar2-week" viewBox="0 0 16 16">
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/>
      <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
    </svg>
    <div class="gjs-block-label">${label}</div>`,
    category: category,
    content: `<div class="${calendarRef}" data-gjs-type="${calendarRef}" data-js="${calendarRef}">
      <img src="https://drapcode-static.s3.amazonaws.com/img/calendar-component.png" alt="Calendar" data-gjs='calendar-placeholder' data-gjs-custom-name="Calendar Placeholder" data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false" data-gjs-selectable="false" data-gjs-highlightable="false"/>
    </div>${style}`,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
}
